// ======================================================================
// File Name       : authority
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { AUTHORITY_RECEIVE_LIST } from '../constants/ActionTypes';

const initialState = {
  authorityInfo: {
    recordNum: null,
    managementAuthorityList: [],
    bySecernId: {},
  },
};

export default function authority(state = initialState, action) {
  switch (action.type) {
    case AUTHORITY_RECEIVE_LIST: {
      const { recordNum, managementAuthorityList } = action;
      const authorityInfo = managementAuthorityList.reduce(
        (acc, cur) => {
          const { managementAuthoritySecernId } = cur;
          acc.bySecernId[managementAuthoritySecernId] = cur;
          return acc;
        },
        { bySecernId: {}, recordNum, managementAuthorityList },
      );
      return { ...state, authorityInfo };
    }
    default:
      return state;
  }
}
